export const environment = {
  production: false,
  environment: 'DEV',
  api_host: 'https://dev.hal.aragon.es/api',
  integration_url: 'https://preaplicaciones.aragon.es',
  cod_procedimiento: 466
};
